// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "LeftNavWrapper-module--bx--text-truncate--end--22NYh";
export var bxTextTruncateFront = "LeftNavWrapper-module--bx--text-truncate--front--hhrlu";
export var expanded = "LeftNavWrapper-module--expanded--3R-a2";
export var leftNavWrapper = "LeftNavWrapper-module--leftNavWrapper--2eJ6K";
export var useHeaderNavStyles = "LeftNavWrapper-module--useHeaderNavStyles--3utek";